import validate from "G:/00_Project/4_Technomac-snc/node_modules/nuxt/dist/pages/runtime/validate.js";
import track_45visit_45global from "G:/00_Project/4_Technomac-snc/middleware/trackVisit.global.ts";
import manifest_45route_45rule from "G:/00_Project/4_Technomac-snc/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  track_45visit_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  admin: () => import("G:/00_Project/4_Technomac-snc/middleware/admin.ts"),
  guest: () => import("G:/00_Project/4_Technomac-snc/middleware/guest.ts")
}